

exports.__esModule = true;
exports.$xoPageAddCardPageComponent = undefined;

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

require('xo-wallet-components/src/add-card/directive');

require('xo-validation/dist/directive');

require('xo-ui-components/src/tooltip/directive');

require('xo-ui-components/src/dropdown/directive');

require('xo-page-components/src/value-props/directive');

require('xo-models/src/fi/lib/fiMessages');

require('xo-models/src/checkout/index');

var _squid = require('squid');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoPageAddCardPageComponent = exports.$xoPageAddCardPageComponent = _squid.$Component.extend('$xoPageAddCardPageComponent', {
    tag: 'xo-page-add-card-page',
    template: _template2['default'],
    scope: {},

    controller: function controller($scope, $rootScope, $state, $locale, $CheckoutSessionModel, $populate, $stateParams, $CheckoutPayeeModel, $CheckoutCartModel, $fiMessages) {
        // eslint-disable-line max-params,no-shadow
        $scope.token = $rootScope.token;
        $scope.locale = $locale;
        $scope.callbacks = {
            finish: function finish() {
                $state.go('checkout.review');
            }
        };

        var models = {};

        $populate(models, {
            checkoutSession: $CheckoutSessionModel.instance($scope.token).retrieve({
                contingencies: {
                    NEED_CREDIT_CARD: angular.noop,
                    EXPIRED_CREDIT_CARD: angular.noop,
                    NEED_DEBIT_CARD: angular.noop,
                    EXPIRED_DEBIT_CARD: angular.noop
                }
            }),
            payee: $CheckoutPayeeModel.instance($scope.token),
            cart: $CheckoutCartModel.instance($scope.token)
        }).then(function () {

            var message = $fiMessages.processorDeclinedMsg(models.checkoutSession, false);

            // If no processor decline, get the message when contingency is anything but NEED_DEBIT_CARD
            if (!message && models.checkoutSession.get('errorData.cause') && $stateParams.message !== 'NEED_DEBIT_CARD') {
                message = $fiMessages.errorMsg(models.payee.isGambling());
            }

            $scope.message = undefined;
            $scope.cart = models.cart;

            if (message) {
                $scope.message = {
                    type: 'info',
                    msgs: [message.msg]
                };
            }
        });

        $scope.isUpdateDebitCard = function () {
            return $stateParams.message === 'EXPIRED_DEBIT_CARD';
        };
    }
});

angular.value("$xoPageAddCardPageComponent", $xoPageAddCardPageComponent);
_squid.$Component;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-add-card/directive.js
// module id = ./pages/xo-add-card/directive.js
// module chunks = 1